import { render, staticRenderFns } from "./CardLicenseNo.vue?vue&type=template&id=50acae6e&"
import script from "./CardLicenseNo.vue?vue&type=script&lang=js&"
export * from "./CardLicenseNo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports